import PageTitle from "../components/pageTitle";
import Login from "../components/users/login";

const LoginPage = () => {
    return <div>
        <PageTitle title="Log in" />
        <Login />
    </div>;
};

export default LoginPage;